'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndexedCombinationsByDisplay = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getIndexedCombinationsByDisplay = exports.getIndexedCombinationsByDisplay = function getIndexedCombinationsByDisplay(layout, combinations) {
  var layoutIds = R.pipe(R.map(R.pluck('id')), R.values, R.unnest, R.indexBy(R.identity))(layout);
  var _R$partition = R.partition(function (comb) {
      return R.has(comb.id, layoutIds);
    }, combinations),
    _R$partition2 = (0, _slicedToArray3.default)(_R$partition, 2),
    combsInLayout = _R$partition2[0],
    combsInCells = _R$partition2[1];
  return {
    cells: combsInCells,
    layout: combsInLayout
  };
};